module.exports = __webpack_public_path__ + "img/logoEng2.c3642e17.png";